import { useSelector } from 'react-redux';

import { useIsQualityEnabled, useIsSecurityEnabled } from '../../../../helpers/features';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import ProjectGroupModule from '../../../../redux/project_grouping';
import useCategorySummary from '../../../issues/IssuesInbox/hooks/useCategorySummary';
import useSetIssuesScope from '../../../issues/IssuesInbox/hooks/useSetIssuesScope';

/**
 * Connects to Redux and returns the necessary data for the Release Group Subnav.
 */
const useReleaseGroupSubnav = (
  projectGroupId: string,
  projectReleaseId?: number,
) => {
  //  Ensure that the scope is correctly set, based on the params.
  //  Returns the scope so it can be passed to the other hook.
  const releaseScanId = useSelector(ProjectGroupModule.selectors.getSelectedScanId);
  const scope = useSetIssuesScope({
    projectGroupId,
    projectReleaseId,
    releaseScanId,
  });

  const categorySummary = useCategorySummary(scope);
  const { isLoading: isCategorySummaryLoading } = useSelector(IssuesV2Store.selectors.getAsyncStatusCategorySummary);
  const totalIssuesCount = useSelector(IssuesV2Store.selectors.getTotalNumberOfIssuesFromSummary);

  const hasSecurity = useIsSecurityEnabled();
  const hasQuality = useIsQualityEnabled();

  return {
    categorySummary,
    totalIssuesCount,
    isCategorySummaryLoading,
    hasSecurity,
    hasQuality,
  };
};

export default useReleaseGroupSubnav;
